"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.namespace = 'subscription';
exports.FETCH_USER_SUBSCRIPTIONS = exports.namespace + "/FETCH_USER_SUBSCRIPTIONS";
//# sourceMappingURL=constants.js.map